import { GetterTree } from 'vuex';
import { State } from '@/stores/orders/state';

export class Getters implements GetterTree<State, any> {
    [key: string]: (state: State, getters: any, rootState: any, rootGetters: any) => any;

    public orders = (state: State) => state.orders;
    public page = (state: State) => state.pageNumber;
    public pageSize = (state: State) => state.pageSize;
    public totalPages = (state: State) => state.totalPages;
    public total = (state: State) => state.total;
    public filterStatus = (state: State) => state.filterStatus;
    public from = (state: State) => state.from;
    public to = (state: State) => state.to;
}
